export const DEMOGRAPHIC_CATEGORIES = [
  '8(a) Business Enterprise (8(a)s)',
  'Disabled Business Enterprise (DBEs)',
  'Minority Business Enterprises (MBEs)',
  'Women Business Enterprises (WBEs)',
  'Veteran Business Enterprises (VBEs)',
  'Disabled Veteran Business Enterprise (DVBEs)',
  'Lesbian, Gay, Bisexual and/or Transgender Owned Business Enterprises (LGBTBEs)',
  'Disability Owned Business Enterprise (DOBEs)',
  'Historically Underutilized Business Zones (HUBZs)',
  'Small Business Enterprise (SBE)'
];

export const ALL_CATEGORIES = 'Any Diverse Category';
